// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var raffleRouter = {
  path: '/raffle',
  component: Layout,
  redirect: '/raffle/list',
  name: 'raffle',
  alwaysShow: true,
  meta: {
    title: '抽奖',
    icon: 'clipboard'
  },
  children: [{
    path: 'edit',
    name: "edit",
    meta: {
      title: '抽奖配置'
    },
    component: function component() {
      return import('@/views/raffle/edit/index');
    }
  }, {
    path: 'list',
    name: "list",
    meta: {
      title: '抽奖记录'
    },
    component: function component() {
      return import('@/views/raffle/list/index');
    }
  }]
};
export default raffleRouter;